<div class="card" [style.background-color]="backgroundColor">
  <div class="left">
    <span class="weight-700" [class.numero-atualizado]="atualizouAgora" [style.font-size]="fontSizeInfo" [style.color]="colorText">
    {{ (isMoeda ? (quantidade | currency:moeda:'symbol':'1.2-2') : quantidade) + (isPorcentagem ? '%' : '') }}
    </span>
  </div>
  <div class="right">
    <span class="font-14 weight-700" [style.color]="colorText">
      {{ titulo }}
    </span>
  </div>
</div>
